import { render, staticRenderFns } from "./ReplaceItemOverlay.vue?vue&type=template&id=c1f2af00&scoped=true"
import script from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
export * from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ReplaceItemOverlay.vue?vue&type=style&index=0&id=c1f2af00&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f2af00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f2af00')) {
      api.createRecord('c1f2af00', component.options)
    } else {
      api.reload('c1f2af00', component.options)
    }
    module.hot.accept("./ReplaceItemOverlay.vue?vue&type=template&id=c1f2af00&scoped=true", function () {
      api.rerender('c1f2af00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/browser/item-overlays/ReplaceItemOverlay.vue"
export default component.exports